import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Switch,
  TextField,
} from '@material-ui/core';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { ExpandMore } from '@material-ui/icons';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useRouteMatch } from 'react-router';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import useSWR, { mutate } from 'swr';
import { getGameById } from '../../../api/cms/game';
import {
  bulkUpdateGameFlags,
  exportGames,
  getCatagoryProvider,
  getGameByProviderId,
  getSortedGames,
  updateProviderConfig,
} from '../../../api/cms/provider';
import { LoadingBox } from '../../../components/LoadingBox';
import TablePaginationActions from '../../../components/table/TablePaginationActions';
import Thead from '../../../components/table/Thead';
import useDebounce from '../../../hooks/useDebounce';
import GameModal from '../game/GameModal';

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  disabled: {
    filter: 'grayscale(100)',
    cursor: 'not-allowed',
  },
  text: {
    fontWeight: 'normal',
    fontSize: '16px',
  },
  spacingSM: {
    padding: '0 0.25rem',
  },
}));

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const GameListTable = ({ providerId, categoryName, order, config }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [open, setOpen] = React.useState(false);
  const [game, setGame] = React.useState();
  const [category, setCategory] = React.useState(undefined);
  const [searchObj, setSearch] = React.useState({
    username: '',
  });
  const [getConfig, setConfig] = React.useState(config);
  const searchDebounce = useDebounce(searchObj, 700);

  const [selectedGames, setSelectedGames] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [bulkFlagAction, setBulkFlagAction] = useState('');

  let testData = [];
  let match = useRouteMatch();
  let cate = [];
  const {
    data = {},
    error,
    mutate,
  } = useSWR(
    ['gameByProviderId', providerId, page, rowsPerPage, searchDebounce, ''],
    (url, providerId) =>
      getGameByProviderId({
        providerId: providerId,
        page: page + 1,
        limit: rowsPerPage,
        search_game: searchDebounce?.username,
        category: categoryName,
      }),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );
  const { data: dataCategory, error: errorDataCategory } = useSWR(
    ['getCatagoryProvider', providerId],
    (url, providerId) => getCatagoryProvider(providerId),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );
  const [sortCriteria, setSortCriteria] = useState('');
  const handleSortChange = async (newSort) => {
    setSortCriteria(newSort);
    await getSortedGames({
      providerId,
      category: categoryName,
      sort_criteria: newSort,
    });
    mutate(); // Re-fetch the data after sorting
  };

  const handleSelectAll = (event) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      setSelectedGames(games.map((g) => g.game_id));
    } else {
      setSelectedGames([]);
    }
  };

  const handleSelectGame = (gameId) => {
    setSelectedGames((prev) =>
      prev.includes(gameId) ? prev.filter((id) => id !== gameId) : [...prev, gameId],
    );
  };

  const handleExport = async () => {
    try {
      const url = await exportGames(providerId, selectedGames);
      if (url) {
        window.open(url, '_blank');
      } else {
        alert('Export failed: no URL returned');
      }
    } catch (err) {
      console.error('Export error:', err);
      alert('Export failed');
    }
  };

  const [expanded, setExpanded] = React.useState(order == 0 ? true : false);
  const onCollapse = () => {
    setExpanded(!expanded);
  };

  if (dataCategory && data != undefined) {
    cate = dataCategory;
    for (var v = 0; v < dataCategory.length; v++) {
      let bbb = { category: cate[v], game: [] };
      testData.push(bbb);
    }
  }

  let isLoading = !error && !data;
  if (error) toast.error(error.error);
  const { games = [], total = 0 } = data;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChange = (event) => {
    setCategory(event.target.value);
    if (event.target.value == 'All') {
      setCategory(undefined);
    } else {
      setCategory(event.target.value);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    if (event.target.value == -1) {
      event.target.value = parseInt(0, 10);
      console.log('limit 0 : ', event.target.value);
      setRowsPerPage(0);
    } else {
      setRowsPerPage(parseInt(event.target.value, 10));
    }
    setPage(0);
  };

  const handleOpenGameDetail = (gameId) => {
    setOpen(true);
    getGameById(gameId).then((data) => {
      setGame(data);
    });
  };

  const handleCloseGameDetail = () => {
    setOpen(false);
    setGame({});
  };

  const handleChangeMaintenance = (evt) => {
    console.log(getConfig);
    const checked = evt.target.checked;
    Swal.fire({
      title: 'Are you sure',
      text: `Do you want to ${
        checked ? 'open' : 'close'
      } ${getConfig.category.toLowerCase()} maintenance`,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      showConfirmButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('changed');
        setConfig({ ...getConfig, is_maintenance: getConfig });
        const config = {
          category_id: getConfig.category_id,
          is_maintenance: checked,
        };
        updateProviderConfig(providerId, config).then((res) => {
          console.log(res);
          if (res.status === 200 && res.data.code === 0) {
            toast.success(`mantenance is ${checked ? 'on' : 'off'}`);
          }
        });
      }
    });
  };

  const handleBulkFlagAction = async (actionValue) => {
    if (!actionValue) return;

    const [field, rawValue] = actionValue.split(':');
    const value = rawValue === 'true';

    try {
      const payload = {
        game_ids: selectedGames,
        [field]: value,
      };
      await bulkUpdateGameFlags(providerId, payload);
      toast.success(`Bulk update successful: ${field} = ${value}`);
      mutate(); // refresh game list
      setSelectedGames([]); // clear selection
      setSelectAll(false);
    } catch (err) {
      console.error('Bulk flag update error:', err);
      toast.error('Bulk update failed');
    }

    setBulkFlagAction('');
  };

  if (isLoading) return <LoadingBox />;
  return (
    <>
      <GameModal open={open} handleClose={handleCloseGameDetail} game={game} />
      <Card style={{ margin: '30px auto' }}>
        <CardHeader
          title={
            <>
              <Box>{categoryName.toUpperCase()}</Box>
              <Box>
                <span className={classes.text}>Maintenance</span>&nbsp;
                <span className={`${classes.text} ${classes.spacingSM}`}>
                  {getConfig?.is_maintenance ? '' : 'off'}
                </span>
                <FormControlLabel
                  control={
                    <Switch
                      size="medium"
                      checked={getConfig?.is_maintenance}
                      onChange={(e) => handleChangeMaintenance(e)}
                    />
                  }
                />
                <span className={`${classes.text} ${classes.spacingSM}`}>
                  {getConfig?.is_maintenance ? 'on' : ''}
                </span>
              </Box>
            </>
          }
          action={
            <IconButton aria-label="collapse" onClick={onCollapse}>
              <ExpandMore />
            </IconButton>
          }
        />
        <Collapse in={expanded}>
          <CardContent spacing={1}>
            <Grid container spacing={2} alignItems="center" style={{ padding: '10px 0px' }}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleExport}
                  disabled={!selectedGames.length}
                >
                  Export
                </Button>
              </Grid>
              <Grid item>
                <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
                  <InputLabel>Sort By</InputLabel>
                  <Select
                    value={sortCriteria}
                    onChange={(e) => handleSortChange(e.target.value)}
                    label="Sort By"
                  >
                    <MenuItem value="top_pick">Top Pick</MenuItem>
                    <MenuItem value="new_game">New Game</MenuItem>
                    <MenuItem value="created_time_desc">Created Date Desc</MenuItem>
                    <MenuItem value="created_time_asc">Created Date Asc</MenuItem>
                    <MenuItem value="game_name_asc">Game Name A-Z</MenuItem>
                    <MenuItem value="game_name_desc">Game Name Z-A</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
                  <InputLabel>Bulk Flag Action</InputLabel>
                  <Select
                    label="Bulk Flag Action"
                    value={bulkFlagAction}
                    onChange={(e) => handleBulkFlagAction(e.target.value)}
                    disabled={!selectedGames.length}
                  >
                    <MenuItem value="">Select Action</MenuItem>
                    <MenuItem value="is_new_game:true">✅ Mark New Game</MenuItem>
                    <MenuItem value="is_new_game:false">❌ Unmark New Game</MenuItem>
                    <MenuItem value="is_top_pick:true">⭐️ Mark Top Pick</MenuItem>
                    <MenuItem value="is_top_pick:false">❌ Unmark Top Pick</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item style={{ marginLeft: 'auto' }}>
                <TextField
                  size="small"
                  variant="outlined"
                  label="Search game name..."
                  onChange={(e) => setSearch({ ...searchObj, username: e.target.value })}
                  value={searchObj?.username}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="game table" size="small">
                  <Thead
                    heads={[
                      {
                        name: <Checkbox checked={selectAll} onChange={handleSelectAll} />,
                        align: 'center',
                      },
                      { name: 'Image', align: 'left' },
                      { name: 'Name (Code)', align: 'left' },
                      { name: 'Category', align: 'left' },
                      { name: 'Flags', align: 'center' },
                      { name: 'Created Date', align: 'left' },
                      { name: 'Order', align: 'center' },
                      { name: 'Edit', align: 'left' },
                    ]}
                  />
                  <TableBody>
                    {games?.map((row, i) => (
                      <StyledTableRow key={row.game_id}>
                        <TableCell padding="checkbox" align="center">
                          <Checkbox
                            checked={selectedGames.includes(row.game_id)}
                            onChange={() => handleSelectGame(row.game_id)}
                          />
                        </TableCell>
                        <TableCell style={{ width: '100px' }}>
                          <img
                            src={row.game_icon_url || '/images/provider/default.jpeg'}
                            className={classnames(row.is_disabled ? classes.disabled : '')}
                            style={{ width: '80px', padding: '0 5px' }}
                          />
                        </TableCell>
                        <TableCell style={{ width: '400px' }} align="left">
                          {row.game_name} ({row.game_code})
                        </TableCell>
                        <TableCell style={{ width: '80px' }} align="left">
                          {row.category}
                        </TableCell>
                        <TableCell align="center">
                          {row.is_new_game && (
                            <FiberNewIcon style={{ color: 'red', verticalAlign: 'middle' }} />
                          )}
                          {row.is_top_picked && (
                            <WhatshotIcon
                              style={{ color: '#f57c00', marginLeft: 4, verticalAlign: 'middle' }}
                            />
                          )}
                          <br />
                          {row.is_disabled && (
                            <Badge
                              badgeContent="Disabled"
                              color="secondary"
                              style={{ marginTop: 4 }}
                            />
                          )}
                        </TableCell>
                        <TableCell align="left">{row.game_created_time ?? ''}</TableCell>
                        <TableCell align="center">{row.order ?? '-'}</TableCell>
                        <TableCell align="left">
                          <Link href={`${match.url}/game/${row.game_id}/edit`}>Edit</Link>
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[25, 50, 100, { label: 'All', value: -1 }]}
                        colSpan={5}
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        // onChangeRowsPerPage={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
    </>
  );
};

export default GameListTable;
